<template>
    <div class="protocol_wrapper">
        <div class="title">Updated: {{ value.updatedAt }}</div>

        <div class="text" v-html="value.text" />
    </div>
</template>

<script>
export default {
    props: {
        value: {
            type: Object,
            required: true
        }
    }
};
</script>
